import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';

/**
 * Everything below the first viewport is code-split so the Hero (LCP) ships
 * with the smallest possible JS payload. Each block reserves vertical space
 * while its chunk loads, which keeps CLS at zero.
 *
 * Recorrido: hero → problema/transformación → bloque oscuro + Método M.V.P.™ →
 * 100 recetas → tus primeras 5 → los 5 bonos → oferta → FAQ → cierre.
 */
const TransformationSection = lazy(() => import('./components/TransformationSection').then(m => ({
  default: m.TransformationSection
})));
const MethodSection = lazy(() => import('./components/MethodSection').then(m => ({
  default: m.MethodSection
})));
const PositioningSection = lazy(() => import('./components/PositioningSection').then(m => ({
  default: m.PositioningSection
})));
const JourneySection = lazy(() => import('./components/JourneySection').then(m => ({
  default: m.JourneySection
})));
const BonosSection = lazy(() => import('./components/BonosSection').then(m => ({
  default: m.BonosSection
})));
const OfferSection = lazy(() => import('./components/OfferSection').then(m => ({
  default: m.OfferSection
})));
const FaqSection = lazy(() => import('./components/FaqSection').then(m => ({
  default: m.FaqSection
})));
const FinalCta = lazy(() => import('./components/FinalCta').then(m => ({
  default: m.FinalCta
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const StickyBuyBar = lazy(() => import('./components/StickyBuyBar').then(m => ({
  default: m.StickyBuyBar
})));
interface DeferredProps {
  children: React.ReactNode;
  minHeight: string;
  background?: string;
}
function Deferred({
  children,
  minHeight,
  background = 'bg-cream'
}: DeferredProps) {
  return <Suspense fallback={<div className={`w-full ${background}`} style={{
    minHeight
  }} aria-hidden data-id="element-1" data-mp="nuhhyhj2w9tr" />} data-id="element-0" data-mp="nw2cw89b1us5">
      {children}
    </Suspense>;
}
export function App() {
  return <main className="w-full bg-cream text-charcoal" data-id="element-2" data-mp="36hx792iaw2a">
      <Hero data-id="element-3" data-mp="356wji4cy4fe" />
      <Deferred minHeight="520px" background="bg-white" data-id="element-4" data-mp="34nbhsjeuzx5">
        <TransformationSection data-id="element-5" data-mp="3udkos1m9b4d1" />
      </Deferred>
      <Deferred minHeight="700px" background="bg-charcoal" data-id="element-6" data-mp="3uevs60bsia3m">
        <MethodSection data-id="element-7" data-mp="d3mn9jzh3bod" />
      </Deferred>
      <Deferred minHeight="620px" background="bg-sand" data-id="element-8" data-mp="d2l7j27ii10b">
        <PositioningSection data-id="element-9" data-mp="86mgt7ypo6wq" />
      </Deferred>
      <Deferred minHeight="520px" background="bg-white" data-id="element-10" data-mp="83qgjcze5654">
        <JourneySection data-id="element-11" data-mp="3gm64lrgm4x4e" />
      </Deferred>
      <Deferred minHeight="640px" data-id="element-12" data-mp="3gj1s86szuv2n">
        <BonosSection data-id="element-13" data-mp="3bn2y02kziiub" />
      </Deferred>
      <Deferred minHeight="820px" background="bg-sand" data-id="element-14" data-mp="3bo4lx7n3mztg">
        <OfferSection data-id="element-15" data-mp="3qbpkqpcxycvk" />
      </Deferred>
      <Deferred minHeight="620px" data-id="element-16" data-mp="3qcimfbx1mc6u">
        <FaqSection data-id="element-17" data-mp="3lkhfm5in9do7" />
      </Deferred>
      <Deferred minHeight="620px" background="bg-white" data-id="element-18" data-mp="3ljg09ouli50o">
        <FinalCta data-id="element-19" data-mp="2xuwsdafgju94" />
      </Deferred>
      <Deferred minHeight="300px" background="bg-sand" data-id="element-20" data-mp="2xtv6sc0tfpd5">
        <Footer data-id="element-21" data-mp="2svtnpr3e3q1o" />
      </Deferred>
      <Suspense fallback={null} data-id="element-22" data-mp="2swliizp5xjqw">
        <StickyBuyBar data-id="element-23" data-mp="2svjw5z2p5atv" />
      </Suspense>
    </main>;
}